import React from 'react'
import { AdminSidebarLayout } from '../../components/AdminSidebar'
import { AdminHeader, OngoingProjectsTable, UnreadNotifications, WeeklyRevenue } from '../../components/components'
import GigsTable from '../../components/Tables/GigsTable'
import IncomeChart from '../../components/admins/Dashboard/IncomeChart'
import MetricsDashboard from '../../components/admins/Dashboard/MetricsCard'


const AdminDashboard = () => {
    return (

        <AdminSidebarLayout currentPath="/dashboard">
            <div className="bg-[#F5F5F5] dark:bg-[#0A0A0A] min-h-screen px-4 py-8 overflow-hidden">
                <AdminHeader/>
                <div className="container mx-auto">
                    <div className="w-full flex flex-col gap-4">
                        <MetricsDashboard/>
                        <div className="flex flex-col md:flex-row items-start gap-4">
                            <IncomeChart/>
                            <WeeklyRevenue/>
                        </div>

                         <div className="flex flex-col md:flex-row items-start gap-4">
                        <OngoingProjectsTable/>
                        <UnreadNotifications/>
                        </div>
                        
                    </div>
                </div>
            </div>
        </AdminSidebarLayout>
    )
}

export default AdminDashboard